import React from "react";

import { Box, Button, Grid, Typography } from "@mui/material";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";

import { AudiogramsResponse } from "../types";
import AudiogramCard from "../components/AudiogramCard";
import LoadingSkeletons from "./LoadingSkeletons";

interface AudiogramCardGridProps {
  isLoading: boolean;
  onGenerateClick: () => void;
  data: AudiogramsResponse;
  episodeId: string;
}

export default function AudiogramCardGrid({
  isLoading,
  onGenerateClick,
  data,
  episodeId,
}: AudiogramCardGridProps) {
  const sorted = [...(data?.audiograms || [])].sort(
    (a, b) =>
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
  );

  if (isLoading) {
    return <LoadingSkeletons />;
  }

  if (!sorted.length) {
    return (
      <Grid item xs={12}>
        <Box sx={{ textAlign: "center", py: 8, px: 2 }}>
          <GraphicEqIcon
            sx={{ fontSize: 64, color: "text.secondary", mb: 2 }}
          />
          <Typography variant="h6" color="text.secondary" gutterBottom>
            No audiograms yet
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Generate your first audiogram to get started
          </Typography>
          <Button
            variant="contained"
            onClick={onGenerateClick}
            size="large"
            sx={{
              backgroundColor: "#2563eb",
              "&:hover": { backgroundColor: "#1d4ed8" },
            }}
          >
            Generate First Audiogram
          </Button>
        </Box>
      </Grid>
    );
  }

  return (
    <>
      {sorted.map((audiogram) => (
        <AudiogramCard
          key={audiogram.id}
          episodeId={episodeId}
          audiogram={audiogram}
        />
      ))}
    </>
  );
}
